// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f192ab00","455":"97c7c72c","946":"d77d29fb"}[chunkId] + ".chunk.js";
};